<template>
  <v-main>
    <v-sheet :height="this.$root.windowHeight">
    <v-row align="center" justify="center" class="fill-height">
      <v-container>
        <v-row align="center" justify="center">
          <span class="text-h1">Error 401</span>
        </v-row>
        <v-row align="center" justify="center">
          Hey, rufián. No tienes permisos para ver esto.
        </v-row>
        <v-row align="center" justify="center">
          <v-btn dark color="#7400b8" class="mt-5" @click="toLogin">
            <v-icon left>
              mdi-home
            </v-icon>
            Inicio
          </v-btn>
        </v-row>
      </v-container>
    </v-row>
    </v-sheet>
  </v-main>
</template>

<script>
export default {
  name: "Error",
  methods: {
    toLogin() {
      this.$router.push('/');
    }
  }
}
</script>

<style scoped>
</style>
